import * as React from 'react';

import { cn } from '../../lib/utils.js';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full items-center rounded-md border border-input bg-background text-base shadow-sm transition-colors file:border-0 file:text-xs file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm file:leading-[34px] file:bg-secondary',
          // Add padding only for non-file inputs
          type !== 'file' && 'px-2',
          className,
        )}
        ref={ref}
        suppressHydrationWarning
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
